module.exports = __webpack_public_path__ + "img/blake-3.e3c46b4f.jpg";